import React from 'react';
import { Section } from './ui/Section';
import { Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <Section className="bg-white text-center" data-id="element-128">
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#D4735E]/10 text-[#D4735E] rounded-full text-sm font-medium mb-6" data-id="element-129">
        <Sparkles className="w-4 h-4" data-id="element-130" />
        La solución
      </div>

      <h2 className="text-4xl md:text-6xl font-serif font-bold text-[#2D2D2D] mb-6" data-id="element-131">
        Sistema de Filtro Femenino™
      </h2>

      <p className="text-xl md:text-2xl text-[#666666] max-w-3xl mx-auto leading-relaxed" data-id="element-132">
        Plan NoMásTóxicos™ es un sistema práctico para cambiar el tipo de
        hombres que atraes y eliges.
      </p>
    </Section>;
}